import { useEffect, useState } from "react";
import { isSupabaseConfigured, supabase } from "@/lib/supabaseClient";

/**
 * Tracks the current Supabase user. Subscribes to auth changes before the
 * initial getUser() so no early sign-in event is missed. Resolves to null when
 * Supabase is not configured.
 */
export const useAuthUser = () => {
  const [user, setUser] = useState<any | null>(null);

  useEffect(() => {
    let mounted = true;

    if (!isSupabaseConfigured || !supabase) {
      setUser(null);
      return () => {
        mounted = false;
      };
    }

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      if (mounted) setUser(session?.user ?? null);
    });

    supabase.auth
      .getUser()
      .then(({ data: { user: u } }) => {
        if (mounted) setUser(u ?? null);
      })
      .catch(() => {});

    return () => {
      mounted = false;
      listener?.subscription?.unsubscribe?.();
    };
  }, []);

  return { user, setUser };
};
